// Resolves an approval slot only through its validated command alias.
import { z } from 'zod';

import { defineCompoundMember } from '@apps/web/features/phoebe_chat_v3/registry/types';

const toolApprovalGrantedPayloadSchema = z
    .object({ command_id: z.uuid() })
    .strip();

export const toolApprovalGrantedDefinitions = {
    tool_approval_granted: defineCompoundMember('tool_approval_granted', {
        disposition: 'compound_member',
        schema: toolApprovalGrantedPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
        slotMember: {
            slot: 'approval',
            terminal: true,
            keys(payload) {
                return [{ kind: 'command_id', value: payload.command_id }];
            },
            fragment(payload) {
                return {
                    kind: 'approval_resolved',
                    commandId: payload.command_id,
                    decision: 'granted',
                };
            },
        },
    }),
} as const;

export const toolApprovalGrantedContractFixtures = {
    valid: { command_id: '0198a846-739e-7a2f-a152-66a77cc11111' },
    malformed: { command_id: 'not-a-uuid' },
} as const;
